import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object, string } from "yup";

import { PurposeInputField } from "./PurposeInputField";
import { PurposeSummaryField } from "./PurposeSummaryField";
import { FieldType } from "../types";

export function PurposeField(
  field: components["schemas"]["PurposeCheckField"]
): FieldType<components["schemas"]["PurposeCheckField"]> {
  return {
    field,
    inputElement: <PurposeInputField key={field.name} field={field} />,
    summaryElement: () => (
      <PurposeSummaryField key={field.name} field={field} />
    ),
    initialValue:
      field.value ??
      ({
        purpose_of_check: "",
        position_title: "",
        place_of_work: "",
        license_type: "",
        issuing_authority: "",
        reason_for_check: "",
      } as unknown as components["schemas"]["PurposeCheckField"]["value"]),
    schema: purposeFieldSchema,
  };
}

export const purposeFieldSchema = object().shape({
  purpose_of_check: string().required().label(t("Purpose of check")),
  position_title: string().when(
    ["purpose_of_check"],
    ([purposeOfCheck], schema) => {
      if (purposeOfCheck === "EMPLOYMENT") {
        return schema.required().label(t("Role or position title"));
      }
      return schema;
    }
  ),
  place_of_work: string().when(
    ["purpose_of_check"],
    ([purposeOfCheck], schema) => {
      if (purposeOfCheck === "EMPLOYMENT" || purposeOfCheck === "OTHER") {
        return schema
          .required()
          .label(t("Organization, type or place of work"));
      }
      return schema;
    }
  ),
  license_type: string().when(
    ["purpose_of_check"],
    ([purposeOfCheck], schema) => {
      if (purposeOfCheck === "LICENSE") {
        return schema.required().label(t("License type"));
      }
      return schema;
    }
  ),
  issuing_authority: string().when(
    ["purpose_of_check"],
    ([purposeOfCheck], schema) => {
      if (purposeOfCheck === "LICENSE") {
        return schema.required().label(t("Issuing authority"));
      }
      return schema;
    }
  ),
  reason_for_check: string().when(
    ["purpose_of_check"],
    ([purposeOfCheck], schema) => {
      if (purposeOfCheck === "OTHER") {
        return schema.required().label(t("Reason for check"));
      }
      return schema;
    }
  ),
});
